import { useEffect, useState } from 'react';
import { fetchList } from '@/lib/api';
import { Reveal } from '@/components/Reveal';
import { useContent } from '@/lib/useContent';

export default function Shop() {
  const content = useContent();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetchList('/settings').then(setSettings).catch(() => {});
  }, []);

  const shopUrl = settings?.shop_url || '';

  return (
    <div data-testid="shop-page" className="mx-auto flex min-h-[70vh] max-w-[900px] flex-col items-center justify-center px-5 pb-24 pt-36 text-center md:pt-44">
      <Reveal>
        <p className="meta-label text-brayo-blue">{content.shop_overline || 'Official Store'}</p>
        <h1 className="display-title mt-4 text-5xl text-brayo-charcoal sm:text-6xl lg:text-7xl">
          {content.shop_title || 'Shop'}
        </h1>
        {shopUrl ? (
          <a
            data-testid="shop-visit-store-btn"
            href={shopUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="arrow-slide meta-label mt-10 inline-flex items-center gap-3 bg-brayo-blue px-8 py-4 text-white transition-colors hover:bg-brayo-charcoal"
          >
            {content.shop_btn || 'Visit Our Store'}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M7 17L17 7M9 7h8v8" /></svg>
          </a>
        ) : (
          <p data-testid="shop-coming-soon" className="meta-label mt-10 text-brayo-dim">
            {content.shop_soon || 'Our new store opens soon.'}
          </p>
        )}
      </Reveal>
    </div>
  );
}